import { InputConfig } from "@cpj-ai/panel-npm-package";

export const inputConfigs: InputConfig[] = [
  {
    name: "email",
    previewSize: 12,
    inputProps: {
      type: "text",
      label: "Email",
      placeholder: "Enter your email",
    },
    rules: {
      required: "This field is required",
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "Invalid email address",
      },
    },
  },
  {
    name: "password",
    previewSize: 12,
    inputProps: {
      type: "password",
      label: "Password",
      placeholder: "Enter your password",
      showStrengthLevel: false,
    },
    rules: {
      required: "This field is required",
    },
  },
];
